// a more general solution that fixes the desktop header covering elements
// when anchor links on page link to them
function fixAnchorLinkOffset() {
  // count of resources to be loaded on the exhibitor page
  const RESOURCES_AJAX_COUNT = 2;

  // Function to adjust scroll position
  function adjustScrollPosition() {
    if (window.location.hash) {
      const targetElement = document.querySelector(window.location.hash);
      // might want to limit this if there are negative effects
      // when the window loads on certain pages
      if (targetElement) {
        // get the correct header depending on what page the user is on (portal or non portal page)
        const header = document.querySelector("header")
          ? document.querySelector("header")
          : document.querySelector("nav");
        const isAdminPortal = document.querySelector("nav") != null;
        let headerHeight = header.getBoundingClientRect().height;
        // headerHeight is irrelevant at xlarge screens and above for admin portal pages
        if(window.Foundation.MediaQuery.is("xlarge") && isAdminPortal) {
          headerHeight = 0;
        }
        const elementPosition =
          targetElement.getBoundingClientRect().top + window.scrollY;
        const offsetPosition = elementPosition - headerHeight;
        window.scrollTo({
          top: offsetPosition,
          behavior: "smooth"
        });
      }
    }
  }

  // Adjust scroll position on page load
  window.addEventListener("loaded", adjustScrollPosition);

  // Adjust scroll position when clicking on anchor links
  const anchorLinks = document.querySelectorAll(
    "a[href^='#']:not([role='tab']):not([role='menuitem'])"
  );
  anchorLinks.forEach((anchorLink) =>
    anchorLink.addEventListener("click", function (event) {
      event.preventDefault();
      window.location.hash = event.currentTarget.hash;
      adjustScrollPosition();
    })
  );

  // if we are on the admin exhibitor page we need to wait until
  // we retrieve all resources from the AJAX requests present on the page otherwise the scroll position
  // will be incorrect return for now another function will handle the offset
  const isExhibitorProfilePage = document.querySelector(".block__editExhibitorProfile"); 
  if(isExhibitorProfilePage) {
    const handleAjaxComplete = () => {
      if(window.currentLoadedCount == RESOURCES_AJAX_COUNT) {
        adjustScrollPosition();
        $(document).off("ajaxComplete", handleAjaxComplete);
      }
    } 
    $(document).on("ajaxComplete", handleAjaxComplete);

  }
}
// Call the function to initialize
fixAnchorLinkOffset();
window.fixAnchorLinkOffset = fixAnchorLinkOffset;
